import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export const RiskRatingTable: React.FC = () => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Typography variant="h6" sx={{ background: '#f4a460', p: 1, borderRadius: 1, mb: 2 }}>
                危險評級表
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
                    <thead>
                        <tr style={{ background: '#eee' }}>
                            <th style={{ border: '1px solid #ccc', padding: 8, width: '25%' }}>後果嚴重性/事故發生可能性</th>
                            <th style={{ border: '1px solid #ccc', padding: 8, width: '25%' }}>不太可能 (1)<br/>雖可想像到, 但可能性極微</th>
                            <th style={{ border: '1px solid #ccc', padding: 8, width: '25%' }}>可能 (2)<br/>預計有機會發生的事故</th>
                            <th style={{ border: '1px solid #ccc', padding: 8, width: '25%' }}>非常可能 (3)<br/>重複發生的事故</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ccc', padding: 8, background: '#f0f0f0', fontWeight: 'bold' }}>
                                非常嚴重 (3)<br/>
                                意外引致即時生命危險或嚴重身體受傷害<br/>
                                (例如:氣體中毒、缺氧、遇溺)
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#fff3e0', textAlign: 'center', fontWeight: 'bold' }}>
                                (3)<br/>中危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#ffcdd2', textAlign: 'center', fontWeight: 'bold' }}>
                                (6)<br/>高危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#ffcdd2', textAlign: 'center', fontWeight: 'bold' }}>
                                (9)<br/>高危險性
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ccc', padding: 8, background: '#f0f0f0', fontWeight: 'bold' }}>
                                嚴重 (2)<br/>
                                意外可導致身體受中等程度傷害<br/>
                                (例如:骨折、皮膚潰瘍等)
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#e8f5e8', textAlign: 'center', fontWeight: 'bold' }}>
                                (2)<br/>低危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#fff3e0', textAlign: 'center', fontWeight: 'bold' }}>
                                (4)<br/>中危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#ffcdd2', textAlign: 'center', fontWeight: 'bold' }}>
                                (6)<br/>高危險性
                            </td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ccc', padding: 8, background: '#f0f0f0', fontWeight: 'bold' }}>
                                輕微 (1)<br/>
                                意外引致身體輕微傷害<br/>
                                (例如:塵埃引致眼睛刺痛、咳嗽等)
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#e8f5e8', textAlign: 'center', fontWeight: 'bold' }}>
                                (1)<br/>低危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#e8f5e8', textAlign: 'center', fontWeight: 'bold' }}>
                                (2)<br/>低危險性
                            </td>
                            <td style={{ border: '1px solid #ccc', padding: 8, backgroundColor: '#fff3e0', textAlign: 'center', fontWeight: 'bold' }}>
                                (3)<br/>中危險性
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Box>

            {/* 顏色圖例 */}
            <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>顏色圖例:</Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: '#ffcdd2', border: '1px solid #ccc' }}></Box>
                        <Typography variant="body2">高危險性</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: '#fff3e0', border: '1px solid #ccc' }}></Box>
                        <Typography variant="body2">中危險性</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: '#e8f5e8', border: '1px solid #ccc' }}></Box>
                        <Typography variant="body2">低危險性</Typography>
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
};